export default "__VITE_ASSET__B0blby7E__"